import * as React from "react";
const SvgFiRrLayerMinus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-layer-minus_svg__a)">
      <path
        fill="#062147"
        d="M12 14.464a3.2 3.2 0 0 1-1.653-.459L.485 8.088a1 1 0 0 1 0-1.714L10.347.456a3.2 3.2 0 0 1 3.307 0l9.861 5.917a1 1 0 0 1 0 1.714l-9.861 5.917a3.2 3.2 0 0 1-1.653.46zM2.944 7.23l8.432 5.06c.385.23.864.23 1.249 0l8.432-5.06-8.433-5.059a1.22 1.22 0 0 0-1.248 0zM24 20a1 1 0 0 0-1-1h-6a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1m-11.143 3.286a1 1 0 0 0-.343-1.372l-10.999-6.6A1 1 0 1 0 .486 17.03l11 6.6a.998.998 0 0 0 1.372-.342zm-.343-4.225 11-6.6a1 1 0 1 0-1.029-1.715L12 17.037l-10.485-6.29a1 1 0 1 0-1.029 1.715l11 6.6a1 1 0 0 0 1.03 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-layer-minus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLayerMinus;
